import { type ReactNode } from 'react'
import { Navigation } from './Navigation'
import { Footer } from './Footer'

interface LayoutProps {
  children: ReactNode
  hideFooter?: boolean
  hideNav?: boolean
}

export function Layout({ children, hideFooter = false, hideNav = false }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {!hideNav && <Navigation />}
      <main className="flex-1">
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  )
}
